module.exports = __webpack_public_path__ + "static/media/60cc6eb2-f69c-7059-2567-eeed39fbe81b.dfb51af0.jpg";